<template>  
	<div @click.stop.prevent="handleClick">    
		<p><strong>Action Plan:</strong></p> 
		<p> 
			Based on the information you entered, body 
			mass index (BMI) is {{bmi}} kg/m2 and unplanned 
			weight loss % is {{percentage}} %. This suggests a <strong>HIGH</strong> risk of 
			being malnourished. 
		</p>
		<p><strong>Local Guidance</strong></p>
		<p>
			<a href="https://manual.rightdecision.scot.nhs.uk/media/1346/dumfries-and-galloway-nutritional-care-assessment-guidelines-for-care-and-nursing-homes-update-may2021-002.pdf" target="_blank">NHS Dumfries and Galloway</a>
		</p>
		<p>
			<strong>National guidance from  <a href="https://www.bapen.org.uk/pdfs/must/must_explan.pdf" target="_blank">BAPEN MUST Explanatory booklet</a></strong>
		</p>
		<p><strong><em>High risk: Treat*</em></strong></p> 
		<ul>
			<li>
				Refer to dietitian, Nutritional 
				Support Team or implement local 
				policy
			</li>
			<li>
				Set goals, improve and increase 
				overall nutritional intake
			</li>
			<li>
				Monitor and review care plan
				<ul>
					<li>Hospital - weekly care</li>
					<li>Home - monthly</li>
					<li>Community - monthly</li> 
				</ul>
			</li>
		</ul>
		<p>
			* Unless detrimental or no benefit is 
			expected from nutritional support e.g. 
			imminent death. 
		</p>
		<p>
			All risk categories:
		</p>
		<ul>
			<li>
				Treat underlying condition and 
				provide help and advice on food 
				choices, eating and drinking 
				when necessary. 
			</li>
			<li>
				Record malnutrition risk 
				category.
			</li>
			<li> 
				Record need for special diets and 
				follow local policy. 
			</li>
		</ul>
		<p>
			Obesity:
		</p>
		<p>
			Record presence of obesity. For those with 
			underlying conditions, these are generally 
			controlled before the treatment of obesity.
		</p>
		<p>
			Re-assess subjects identified at risk as they 
			move through care settings.
		</p>
	</div>
</template>

<script>
	export default {
		name: "High",
		props: {
			bmi: String,
			percentage: String
		},
		methods: {					
			handleClick(e) {
				if (e.target.matches("a")) {
					let url = e.target.href;
					let target = e.target.target == "_blank" ? "_blank" : "_self";
					let dataId = e.target.dataset.id == null ? -1 : e.target.dataset.id;
					var isnativeapp = document.getElementById("isnativeapp");
					if (isnativeapp === undefined || isnativeapp === null) 
					{
						window.open(url,target);  
					}
					else{
						if(target == "_blank") {
							let data = {title:'',nodeid: dataId, href:url, target: target};
							window.Native('dataCallback', data);
						} 
					}	
				}
			},
		}
	};
</script>
